function extractReviewsFromHtml (html) {
  /* global DOMParser */
  const parser = new DOMParser()
  const doc = parser.parseFromString(html, 'text/html')
  const reviews = []

  const reviewElements = doc.querySelectorAll('.jdgm-rev')

  reviewElements.forEach(reviewElement => {
    const review = {}

    review.author = reviewElement.querySelector('.jdgm-rev__author').textContent.trim()
    review.rating = parseInt(reviewElement.querySelector('.jdgm-rev__rating').getAttribute('data-score'), 10)
    review.title = reviewElement.querySelector('.jdgm-rev__title').textContent.trim()
    review.content = reviewElement.querySelector('.jdgm-rev__body').textContent.trim()
    review.timestamp = reviewElement.querySelector('.jdgm-rev__timestamp').getAttribute('data-content')

    reviews.push(review)
  })

  return reviews
}

export default extractReviewsFromHtml
